<template>
    <div class="artifact-detail">
        <div class="title-body ps-3 py-2">
            Chi tiết hiện vật
        </div>
        <div class="height-body pt-4 pb-5 mx-3 form-edit">
            <div>
                <label for="title" class="form-label mb-1">Tên hiện vật</label>
                <vue-editor v-model="artifact.title" :editorToolbar="customToolbar" id="title-artifact"></vue-editor>
            </div>
            <div class="form-check form-switch mt-3">
                <input class="form-check-input" type="checkbox" role="switch" id="imgVertical" v-model="artifact.vertical">
                <label class="form-check-label" for="imgVertical">Hiện vật ảnh chân dung</label>
            </div>
            <div class="form-check form-switch mt-3">
                    <input class="form-check-input" type="checkbox" role="switch" id="imgPopup" v-model="artifact.popup">
                    <label class="form-check-label" for="imgPopup">Hiện vật ảnh full màn hình</label>
                </div>
            <div class="mt-3">
                <div class="mb-1">Ảnh đại diện hiện vật<span class="note-preview ms-1">(Xoá ảnh đại diện hiện tại nếu muốn thay ảnh đại diện)</span></div>
                <div class="thumb-img-preview position-relative" v-if="artifact.thumbImg">
                    <img :src="`${url}/images/${artifact.thumbImg}`" :alt="artifact.thumbImg"/>
                    <div class="btn-del position-absolute" data-bs-toggle="modal" data-bs-target="#delImg-thumb">
                        <i class="icon ion-ios-close"></i>
                    </div>
                    <div class="modal fade modal-custom modal-del" id="delImg-thumb" tabindex="-1" aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header p-2 bg-danger">
                                    <div class="modal-title text-white">Xoá ảnh đại diện hiện vật</div>
                                    <button type="button" class="btn text-white" data-bs-dismiss="modal"><i class="icon ion-md-close"></i></button>
                                </div>
                                <div class="modal-body">
                                    <div class=" text-center py-4 fw-bold">
                                        Bạn chắc chắn muốn xoá ảnh đại diện hiện vật?
                                    </div>
                                    <div class="mt-3 text-center">
                                        <button type="button" class="btn btn-danger me-2" @click="delThumb()">Xoá ảnh</button>
                                        <button type="button" class="btn btn-secondary ms-2 px-4" data-bs-dismiss="modal">Huỷ</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="thumb-img mt-3" v-else>
                    <file-pond
                        class="custom-pond"
                        name="image"
                        ref="pond"
                        label-idle="Kéo hình ảnh hoặc chọn"
                        accepted-file-types="image/jpeg, image/png"
                        :server="`${url}/api/upload`"
                        v-model="thumbImg"
                        imagePreviewHeight="200"/>
                </div>
            </div>
            <div class="mt-3">
                <label for="link3d" class="form-label mb-1">Link 3D</label>
                <input type="text" class="form-control" id="link3d" v-model="artifact.link3d">
            </div>
            <div class="mt-3">
                <label for="linkyt" class="form-label mb-1">Link Youtube</label>
                <input type="text" class="form-control" id="linkyt" v-model="artifact.linkYt">
            </div>
            <div class="mt-3">
                <label for="linkaudio" class="form-label mb-1">Link Audio</label>
                <input type="text" class="form-control" id="linkaudio" v-model="artifact.linkAudio">
            </div>
            <div class="mt-3">
                <label for="content" class="form-label mb-1">Nội dung</label>
                <vue-editor v-model="artifact.content" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="mt-3">
                <p class="mb-1">Hình ảnh</p>
                <div class="show-img mb-2">
                    <div class="d-flex flex-wrap">
                        <div class="img-item p-2 position-relative" v-for="(item, index) in listImg" :key="index">
                            <img :src="`${url}/images/${item}`" :alt="item"/>
                            <div class="btn-del position-absolute" data-bs-toggle="modal" :data-bs-target="`#delImg-${index}`">
                                <i class="icon ion-ios-close"></i>
                            </div>
                            <div class="modal fade modal-custom modal-del" :id="`delImg-${index}`" tabindex="-1" aria-hidden="true">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header p-2 bg-danger">
                                            <div class="modal-title text-white">Xoá ảnh hiện vật</div>
                                            <button type="button" class="btn text-white" data-bs-dismiss="modal"><i class="icon ion-md-close"></i></button>
                                        </div>
                                        <div class="modal-body">
                                            <div class=" text-center py-4 fw-bold">
                                                Bạn chắc chắn muốn xoá ảnh này khỏi hiện vật?
                                            </div>
                                            <div class="mt-3 text-center">
                                                <button type="button" class="btn btn-danger me-2" @click="delImg(index)">Xoá ảnh</button>
                                                <button type="button" class="btn btn-secondary ms-2 px-4" data-bs-dismiss="modal">Huỷ</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <file-pond
                    class="custom-pond"
                    name="image"
                    ref="pond"
                    label-idle="Kéo hình ảnh(nhiều) hoặc chọn"
                    allow-multiple="true"
                    accepted-file-types="image/jpeg, image/png"
                    :server="`${url}/api/upload`"
                    v-model="img"/>
            </div>
            <div class="btn-comfirm text-center mt-4">
                <button  class="btn btn-success" @click="editArtifact()">Lưu thay đổi</button>
            </div>
        </div>
    </div>
</template>

<script>
import vueFilePond from "vue-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { VueEditor } from "vue2-editor";
import { apiPut } from '../../config/api';
const FilePond = vueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType);
export default {
    components: {
        FilePond, VueEditor,
    },
    data() {
        return {
            artifact: {
                title: '',
                link3d: '',
                linkYt: '',
                linkAudio: '',
                content: '',
                images: '',
                thumbImg: '',
                vertical: 0,
                popup: 0,
            },
            listImg: [],
            thumbImg: '',
            img: [],
            url: process.env.VUE_APP_API_URL,
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ align: "" },{ align: "center" },{ align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }],
                ["code-block"],
            ]
        }
    },

    computed: {
        id() {
            return this.$route.params.id ? parseInt(this.$route.params.id) : '';
        },
    },

    created() {
        this.getDetailArtifact();
    },

    methods: {
        getDetailArtifact() {
            apiGet(`/artifact/show/${this.id}`).then(res => {
                if(Object.keys(res).length === 0 && res.constructor === Object) {
                    this.$router.push({
                        name: 'artifact',
                    });
                } else {
                    this.artifact.title = res.title;
                    this.artifact.link3d = res.link_3d;
                    this.artifact.linkYt = res.youtube;
                    this.artifact.linkAudio = res.audio;
                    this.artifact.content = res.text;
                    this.artifact.thumbImg = res.thumb_img;
                    this.artifact.vertical = parseInt(res.img_vertical);
                    this.artifact.popup = parseInt(res.popup_full);
                    if(res.images) {
                        this.listImg = res.images.split(',');
                    }
                }
            }).catch(err => {
                console.log(err);
            });
        },

        editArtifact() {
            let list = [];
            this.img.map(function(value, key) {
                let getImg = JSON.parse(value.serverId);
                list.push(getImg);
            })
            let listEdit = this.listImg.concat(list);
            this.artifact.images = listEdit.toString();

            if(this.thumbImg != '') {
                this.artifact.thumbImg = JSON.parse(this.thumbImg[0].serverId);
            }

            apiPut(`/artifact/edit/${this.id}`, {
                title: this.artifact.title,
                link_3d: this.artifact.link3d,
                youtube: this.artifact.linkYt,
                audio: this.artifact.linkAudio,
                text: this.artifact.content,
                images: this.artifact.images,
                thumb_img: this.artifact.thumbImg,
                img_vertical: this.artifact.vertical,
                popup_full: this.artifact.popup,
            }).then(res => {
                this.$toast.success(res.message, {
                    timeout: 3000,
                });
                location.reload();
            }).catch(err => {
                console.log(err);
            })
        },

        delImg(e) {
            this.listImg.splice(e, 1);
            this.editArtifact();
        },

        delThumb() {
            this.artifact.thumbImg = '';
            this.editArtifact();
        }
    }
}
</script>

<style lang="scss">
.artifact-detail {
    .custom-pond {
        .filepond--credits {
            display: none !important;
        }
        .filepond--list {
            .filepond--item {
                width: 24%;
            }
        }
    }
    .btn-comfirm {
        button {
            padding: 10px 100px;
        }
    }
    .show-img {
        .img-item {
            width: 20%;
            &:hover {
                .btn-del {
                    display: block !important;
                }
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 8px;
                box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
            }
        }
    }
    .btn-del {
        top: 15px;
        right: 15px;
        background: rgba(0, 0, 0, 0.5);
        padding: 0px 9px;
        border-radius: 50%;
        cursor: pointer;
        display: none;
        border: 2px solid #fff;
        i {
            &::before {
                font-size: 25px;
                color: #fff;
                padding: 1px;
            }
        }
    }
    .modal-custom {
        .modal-dialog {
            margin-top: 15%;
            .modal-content {
                border: none;
                .modal-header {
                    font-size: 18px;
                    font-weight: 600;
                    border: none;
                }
            }
        }
    }
    .thumb-img {
        width: 300px;
        .filepond--item {
            width: 100% !important;
        }
    }
    .thumb-img-preview {
        width: 20%;
        &:hover {
            .btn-del {
                display: block !important;
            }
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
            box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
        }
        .btn-del {
            top: 10px !important;
            right: 10px !important;
        }
    }
    .note-preview {
        color: #666;
        font-size: 12px;
    }
}
</style>
